import { Link } from "@tanstack/react-router";

import { brand } from "@/lib/brand";
import { firstIntakeStepId } from "@/lib/routes";
import { cn } from "@/lib/utils";

type LogoProps = {
  className?: string;
  markClassName?: string;
  href?: string;
};

export function Logo({ className, markClassName, href }: LogoProps) {
  const content = (
    <>
      <img
        src={brand.assets.logoMark}
        alt=""
        width={40}
        height={44}
        className={cn("h-10 w-auto object-contain", markClassName)}
      />
      <span className="font-heading text-[15px] font-semibold tracking-[0.2em] text-primary uppercase">
        {brand.name}
      </span>
    </>
  );

  if (href) {
    return (
      <a
        href={href}
        className={cn(
          "inline-flex items-center gap-3 text-foreground no-underline",
          className,
        )}
        aria-label={brand.name}
      >
        {content}
      </a>
    );
  }

  return (
    <Link
      to="/intake/$stepId"
      params={{ stepId: firstIntakeStepId() }}
      className={cn(
        "inline-flex items-center gap-3 text-foreground no-underline",
        className,
      )}
      aria-label={brand.name}
    >
      {content}
    </Link>
  );
}
